import { IMultiSuggestResult } from '@cian/geosuggest-widget';

import { TThunkAction } from '../../../types/redux';
import { IGetGeoSuggestParams } from './types';
import {
  EQueryParameters,
  fetchSuggestRealtorForm,
  TSuggestRealtorFormResponse,
} from '../../../repositories/geo-suggest/v1/suggest-realtor-form';
import { prepareSuggestions } from '../../../mappers/prepareGeo';

export const getByTypes = (params: IGetGeoSuggestParams): TThunkAction<Promise<IMultiSuggestResult>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    const defaultData = {
      sortOrder: [],
      suggestions: {},
    };

    try {
      const suggestData: TSuggestRealtorFormResponse = await fetchSuggestRealtorForm({
        httpApi,
        parameters: {
          query: params.request,
          regionId: params.location.id,
          suggestionTypes: params.types as unknown as EQueryParameters[],
        },
      });

      if (suggestData.statusCode === 200) {
        return prepareSuggestions(suggestData.response);
      }

      if (suggestData.statusCode !== 400) {
        logger.warning('Invalid geo suggest api request');
      }

      return defaultData;
    } catch (error) {
      logger.warning('Unable to send geo suggest api request', error);

      return defaultData;
    }
  };
};
